module.exports = __webpack_public_path__ + "static/media/charge_issue.b264571d.mp3";